const Catalog = () =>
  import(/* webpackChunkName: "Catalog" */ "@/components/ssp/eurofins-catalog/Catalog.vue");

export default [
  {
    path: "catalog",
    name: "eurofins-catalog",
    component: Catalog,
  },
];
